import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Applyjobpage.css';

export default function ApplyIntoJobpage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [job, setJob] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    currentCTC: "",
    expectedCTC: "",
    email: "",
    resume: null
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (location.state?.job) {
      setJob(location.state.job);
    } else {
      navigate('/career');
    }
  }, [location.state, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && (file.type === "application/pdf" || file.type.includes('word'))) {
      if (file.size < 5 * 1024 * 1024) {
        setFormData({ ...formData, resume: file });
      } else {
        alert("File size must be less than 5MB.");
        e.target.value = "";
      }
    } else {
      alert("Please upload PDF or Word document only.");
      e.target.value = "";
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  const submitData = new FormData();
  submitData.append('name', formData.name);
  submitData.append('phone', formData.phone);
  submitData.append('currentCTC', formData.currentCTC);
  submitData.append('expectedCTC', formData.expectedCTC);
  submitData.append('email', formData.email);
  if (formData.resume) {
    submitData.append('resume', formData.resume);
  }
  submitData.append('jobDetails', JSON.stringify(job));

  try {
    const response = await fetch('http://localhost:5000/api/jobs/apply', {
      method: 'POST',
      body: submitData,
    });

    const result = await response.json();

    if (result.success) {
      alert("✅ " + result.message);
      navigate('/career');
    } else {
      alert("❌ " + result.message);
    }
  } catch (error) {
    alert("❌ Failed to submit. Please try again.");
    console.error('Submit error:', error);
  } finally {
    setIsSubmitting(false);
  }
};


  if (!job) return <div className="job-apply-loading">Loading...</div>;

  return (
    <div className="job-apply-container">
      <div className="job-apply-main-content">
        <div className="job-apply-container-fluid">
          <div className="job-apply-row justify-content-center">
            <div className="job-apply-col">

              <div className='row'>
                <div className='col-6'>
                  <div className="job-apply-role-display">
                    <div>
                      <h2 className="job-apply-role-title">{job.jobtitle || job.title}</h2>
                      <p className="job-apply-role-subtitle">
                        {job.companyName || job.company} • {job.jobLoc || job.location}
                      </p>
                    </div>
                    <div className="job-apply-role-description">
                      {job.description}
                    </div>
                  </div>
                </div>

                <div className='col-6'>
                  <div className="job-apply-form-card">
                    <form onSubmit={handleSubmit} className="job-apply-compact-form">

                      {/* Row 1: Name + Phone */}
                      <div className="job-apply-form-row">
                        <div className="job-apply-form-group">
                          <label className="job-apply-form-label">Full Name <span className="job-apply-required-mark">*</span></label>
                          <input
                            type="text"
                            name="name"
                            className="job-apply-form-control"
                            placeholder="Enter your name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                        <div className="job-apply-form-group">
                          <label className="job-apply-form-label">Phone Number</label>
                          <input
                            type="tel"
                            name="phone"
                            className="job-apply-form-control"
                            placeholder="+91 xxxxxxxxxx"
                            value={formData.phone}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      {/* Row 2: CTC Fields */}
                      <div className="job-apply-form-row">
                        <div className="job-apply-form-group">
                          <label className="job-apply-form-label">Current CTC (LPA)</label>
                          <input
                            type="number"
                            name="currentCTC"
                            className="job-apply-form-control"
                            placeholder="CurrentCTC"
                            value={formData.currentCTC}
                            onChange={handleInputChange}
                            step="0.1"
                          />
                        </div>
                        <div className="job-apply-form-group">
                          <label className="job-apply-form-label">Expected CTC (LPA) <span className="job-apply-required-mark">*</span></label>
                          <input
                            type="number"
                            name="expectedCTC"
                            className="job-apply-form-control"
                            placeholder="ExpectedCTC"
                            value={formData.expectedCTC}
                            onChange={handleInputChange}
                            required
                            step="0.1"
                          />
                        </div>
                      </div>

                      {/* Email - PERFECT EQUAL SPACING */}
                      <div className="job-apply-form-row">
                        <div className="job-apply-form-group job-apply-full-width-group">
                          <label className="job-apply-form-label">Email Address <span className="job-apply-required-mark">*</span></label>
                          <input
                            type="email"
                            name="email"
                            className="job-apply-form-control"
                            placeholder="your.email@example.com"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>

                      {/* Resume Upload - PERFECT EQUAL SPACING */}
                      <div className="job-apply-form-group job-apply-full-width-file">
                        <label className="job-apply-form-label">Upload Resume <span className="job-apply-required-mark">*</span> (PDF, DOC, DOCX - Max 5MB)</label>
                        <input
                          type="file"
                          name="resume"
                          className="job-apply-form-control"
                          accept=".pdf,.doc,.docx"
                          onChange={handleFileUpload}
                          required={!formData.resume}
                        />
                        {formData.resume && (
                          <div className="job-apply-file-preview">
                            <i className="bi bi-check-circle-fill"></i>
                            {formData.resume.name}
                          </div>
                        )}
                      </div>

                      {/* Buttons */}
                      <div className="job-apply-btn-group">
                        <button
                          type="submit"
                          className="job-apply-btn-submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <>
                              <span className="job-apply-spinner"></span>
                              Submitting
                            </>
                          ) : (
                            "Submit"
                          )}
                        </button>
                        <button
                          type="button"
                          className="job-apply-btn-cancel"
                          onClick={() => navigate('/career')}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
